export const checksums = {
  "spectacles": "v3.5.0--jIaeQsGYMxci3mFHZqg08FpoJ9S1aShkzVYETmJ7V4w",
  "collectif": "v3.5.0--nJneOpdwTvTWxm36Qu74_N8SQu2U_G64aoG5iwoNnBI",
  "contact": "v3.5.0--N8tabjSqbJuUZjdMW894PhNiPa8DtJ9IjMJokQn-9UU"
}
export const checksumsStructure = {
  "spectacles": "6wqw8AXva3EWM64JRd6NoX4Dkpagqwj_3vReJ1xKm_4",
  "collectif": "d22zzy9OsanpC5Z9PuquYRTTLiET_2Llwnp--YiTTVA",
  "contact": "4iTju1r-kn8bUAFP7bwkuZ7ASKYK6M58pzQIIZpvyAI"
}

export const tables = {
  "spectacles": "_content_spectacles",
  "collectif": "_content_collectif",
  "contact": "_content_contact",
  "info": "_content_info"
}

export default {
  "spectacles": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "year": "string",
      "credits": "json",
      "description_short": "json",
      "color": "string",
      "images": "json",
      "dates": "json"
    }
  },
  "collectif": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "images": "json",
      "people": "json"
    }
  },
  "contact": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "images": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}